// import { create } from 'zustand'

// export const useToken = create((set) => ({
//   token: localStorage.getItem("token"),
//   setToken: (token) => set((state) => { 
//     localStorage.setItem("token",token);
//     return { token };
//   }),
// }))


import { create } from 'zustand';

export const useToken = create((set) => ({
  token: localStorage.getItem('token') || null, // Load token from localStorage on page load
  setToken: (newToken) => {
    localStorage.setItem('token', newToken); // Save token to localStorage
    set({ token: newToken });
  },
  removeToken: () => {
    localStorage.removeItem('token'); // Remove token from localStorage
    set({ token: null }); // Clear the state token
  },
  logout: () => {
    localStorage.removeItem('token'); // Remove token from localStorage
    set({ token: null }); // Clear the state token
  }
}));

